<template>
	<div id="ProductModalComponent">
		<div class="modal fade" id="productModalComponent" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Producto</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-row">
							<div class="form-group col-md-2">
								<label for="inputId">Código</label>
								<div class="input-group input-group-sm">
									<input type="number" class="form-control" id="inputId" placeholder="Código" v-model="item.id" :disabled="(item.exists == 1)">
									<div class="input-group-prepend">
										<div class="input-group-text pointer" id="btnGroupAddon" title:="Imprimit etiqueta">
											<i class="fas fa-ticket-alt" data-toggle="modal" data-target="#printerLabelModal" @click="btnPrinterLabelLocal"></i>
										</div>
									</div>
								</div>
							</div>
							<div class="form-group col-md-7">
								<label for="inputName">Titulo</label>
								<input type="text" class="form-control form-control-sm" id="inputName" placeholder="Titulo" v-model="item.name">
							</div>
							<div class="form-group col-md-3">
								<label for="inputSynthetic">Sintetico</label>
								<input type="text" class="form-control form-control-sm" id="inputSynthetic" placeholder="Sintetico" v-model="item.synthetic">
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-md-4">
								<label for="inputISBN">ISBN</label>
								<input type="text" class="form-control form-control-sm" id="inputISBN" placeholder="ISBN" v-model="item.isbn">
							</div>
							<div class="form-group col-md-2">
								<label for="inputLength">Largo</label>
								<input type="number" class="form-control form-control-sm" id="inputLength" placeholder="Largo" v-model="item.length">
							</div>
							<div class="form-group col-md-2">
								<label for="inputWidth">Ancho</label>
								<input type="number" class="form-control form-control-sm" id="inputWidth" placeholder="Ancho" v-model="item.width">
							</div>
							<div class="form-group col-md-2">
								<label for="inputHeight">Alto (grosor)</label>
								<input type="number" class="form-control form-control-sm" id="inputHeight" placeholder="Alto (grosor)" v-model="item.height">
							</div>
							<div class="form-group col-md-2">
								<label for="inputWeight">Peso</label>
								<input type="number" class="form-control form-control-sm" id="inputWeight" placeholder="Peso" v-model="item.weight">
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-md-2">
								<label for="inputGroup">Grupo</label>
								<select id="inputGroup" class="form-control form-control-sm" v-model="item.group">
									<option value="U">Unico</option>
									<option value="G">Grupo</option>
									<option value="P">Suscripción</option>
								</select>
							</div>
							<div class="form-group col-md-2">
								<label for="inputTypeProduct">Tipo de Producto</label>
								<select id="inputTypeProduct" class="form-control form-control-sm" v-model="item.type_product_id">
									<option v-for="(i, index) in listTypesProduct" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
							<div class="form-group col-md-2">
								<label for="inputTypeBinding">Encuadernación</label>
								<select id="inputTypeBinding" class="form-control form-control-sm" v-model="item.type_binding_id">
									<option v-for="(i, index) in listTypesBinding" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
							<div class="form-group col-md-2">
								<label for="inputStatus">Estado</label>
								<select id="inputStatus" class="form-control form-control-sm" v-model="item.status_id">
									<option v-for="(i, index) in listStatus" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
							<div class="form-group col-md-2">
								<label for="inputEditorial">Editorial</label>
								<select id="inputEditorial" class="form-control form-control-sm" v-model="item.editorial_id">
									<option v-for="(i, index) in listEditorials" :key="index" :value="i.id">{{ i.name }}</option>
								</select>
							</div>
						</div>
						<div class="text-right">
							<small class="text-info pointer" v-if="item.exists == 0" data-toggle="modal" data-target="#articuloGenesysModal" @click="showArticuloGenesysModal">Trear desde genesys</small>
							<small class="text-muted" v-else><i>* Para realizar cambios debe precionar enter</i></small>
						</div>
						<div v-if="item.exists === 1">
							<hr>
							<ul class="nav nav-tabs" id="myTab" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" id="location-tab" data-toggle="tab" href="#location" role="tab" aria-controls="location" aria-selected="true">Ubicación</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" id="price-list-tab" data-toggle="tab" href="#price-list" role="tab" aria-controls="price-list-" aria-selected="false">Lista de Precios</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Contact</a>
								</li>
							</ul>
							<div class="tab-content" id="myTabContent">
								<div class="tab-pane fade show active margin-top5" id="location" role="tabpanel" aria-labelledby="location-tab">
									<table class="table table-sm table-hover table-12">
										<thead>
											<tr class="text-center">
												<th>Bodega</th>
												<th>Rack</th>
												<th>Modulo</th>
												<th>Cantidad</th>
												<th class="text-right"><i class="fas fa-plus-circle text-primary pointer" data-toggle="modal" data-target="#assignLocationProductModal" @click="addProductLoationLocal"></i></th>
											</tr>
										</thead>
										<tbody>
											<tr class="text-center" v-for="(it, index) in item.product_locations" :key="index">
												<td>{{ it.store }}</td>
												<td>{{ it.store_rack }}</td>
												<td>{{ it.store_rack_module }}</td>
												<td>
													<input type="number" class="text-right width-50" id="packages"
														v-model="it.quantity"
														@blur="it.quantity = it.quantityOld"
														@focus="$event.target.select(); it.quantityOld = it.quantity"
														v-on:keyup.enter="setValues(it.id, it.quantity, it.quantityOld)"/>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="tab-pane fade margin-top5" id="price-list" role="tabpanel" aria-labelledby="price-list-tab">
									<table class="table table-sm table-hover table-12">
										<thead>
											<tr>
												<th class="text-center">Lista de Precio</th>
												<th class="text-center">Fecha de inicio</th>
												<th class="text-center">Fecha de termino</th>
												<th class="text-center">Cantidad minima</th>
												<th class="text-center">Precio</th>
												<th class="text-right"><i class="fas fa-plus-circle text-primary pointer" @click="addProductPriceListLocal"></i></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(it, index) in item.product_price_list" :key="index">
												<td class="text-center">{{ it.price_list }}</td>
												<td class="text-center">{{ it.date_begin }}</td>
												<td class="text-center">{{ it.date_end }}</td>
												<td class="text-center">{{ it.quantity }}</td>
												<td class="text-center">{{ it.price }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
							</div>
						</div>
					</div>
					<div class="modal-footer text-left">
						<div class="form-check form-check-inline" v-if="item.exists === 0">
							<input class="form-check-input" type="checkbox" id="notClose" value="option1" v-model="closeAfterSave">
							<label class="form-check-label" for="notClose">Seguir agregando productos</label>
						</div>
						<button type="button" class="btn btn-primary btn-sm" @click="saveProduct">Guardar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" ref="btnCloseProductModalComponent">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" tabindex="-1" role="dialog" id="articuloGenesysModal">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Busqueda de articulo de genesys</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<nav class="navbar navbar-light bg-light">
							<div class="form-inline">
								<input class="form-control form-control-sm mr-sm-1" type="text" placeholder="Buscar" aria-label="Buscar" ref="searchArticulos"
									v-model="searchArticulos"
									v-on:keyup.enter="getArticulosLocal()"
									@focus="$event.target.select()">
								<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getArticulosLocal">Buscar</button>
								<div class="float-right d-none d-sm-inline separator"></div>
							</div>
						</nav>

						<table class="table table-sm table-12 table-hover">
							<thead>
								<tr>
									<th>Código</th>
									<th>Articulo</th>
									<th>Sintetico</th>
									<th>ISBN</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(it, index) in listArticulos" :key="index">
									<td>{{ it.codart }}</td>
									<td>{{ it.artdesc }}</td>
									<td>{{ it.sintetico }}</td>
									<td>{{ it.isbn }}</td>
									<td>
										<i class="fas fa-file-import pointer" @click="traerArticulo(it)"></i>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" ref="btnArticuloGenesysModal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" tabindex="-1" role="dialog" id="assignLocationProductModal">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Asignar ubicación</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form>
							<div class="form-group">
								<label for="storeSelect">Bodega</label>
								<select class="form-control form-control-sm" id="storeSelect" v-model="objectProductLocations.store_id" @change="objectProductLocations.store_rack_id = ''">
									<option v-for="(it, index) in listStores" :key="index" :value="it.id">{{it.name}}</option>
								</select>
							</div>
							<div class="form-group">
								<label for="storeRackSelect">Rack</label>
								<select class="form-control form-control-sm" id="storeRackSelect" v-model="objectProductLocations.store_rack_id" @change="objectProductLocations.store_rack_module_id = ''">
									<option v-for="(it, index) in listStoreRacksLocal" :key="index" :value="it.id">{{it.name}}</option>
								</select>
							</div>
							<div class="form-group">
								<label for="storeRackModuleSelect">Modulo</label>
								<select class="form-control form-control-sm" id="storeRackModuleSelect" v-model="objectProductLocations.store_rack_module_id">
									<option v-for="(it, index) in listStoreRackModulesLocal" :key="index" :value="it.id">{{it.name}}</option>
								</select>
							</div>
							<div class="form-group">
								<label for="quantityInput">Cantidad</label>
								<input type="number" class="form-control form-control-sm text-right" id="quantityInput" v-model="objectProductLocations.quantity">
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click="saveProductLocation">Asignar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" ref="btnArticuloGenesysModal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" tabindex="-1" role="dialog" id="addProductPriceListModal">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Asignar precios Lista de Precio</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-3">
								<div class="card card-info">
									<div class="card-body" style="padding: 5px 10px">
										<div class="input-group mb-3">
											<label v-show="1 == 0" for="searchProductList" ref="searchProductList"></label>
											<input type="text" class="form-control form-control-sm" placeholder="Ingrese producto a buscar" aria-label="Ingrese producto a buscar" aria-describedby="basic-addon2" id="searchProductList"
												>
											<div class="input-group-append">
												<button class="btn btn-outline-secondary btn-sm" type="button"><i class="fas fa-search"></i></button>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-9">
								<table class="table table-sm table-12">
									<thead>
										<tr>
											<th class="text-center">Codigo</th>
											<th class="text-center">Producto</th>
											<th class="text-center">Encu</th>
											<th class="text-center">Fecha Inicio</th>
											<th class="text-center">Fecha Termino</th>
											<th class="text-center">Cantidad min</th>
											<th class="text-center">Precio</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th>298</th>
											<th>El maravilloso mundo de la Biblia para los niños</th>
											<th>DURA</th>
											<th>
												<input type="date" class="text-center width-125"/>
											</th>
											<th>
												<input type="date" class="text-center width-125"/>
											</th>
											<th>
												<input type="number" class="text-right width-100"/>
											</th>
											<th>
												<input type="number" class="text-right width-100"/>
											</th>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click="saveProductLocation">Guardar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" ref="btnArticuloGenesysModal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" tabindex="-1" role="dialog" id="printerLabelModal">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Impresión de Etiqueta</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<select class="form-control form-control-sm" v-model="selectedLabelId">
								<option value="7">Articulo</option>
								<option value="6">Caja</option>
							</select>
						</div>
						<div class="form-group" v-if="selectedLabelId == 6">
							<label for="quantityProduct">Cantidad por caja</label>
							<input type="number" class="form-control form-control-sm" id="quantityProduct" v-model="quantityProduct"/>
						</div>
						<div class="form-group">
							<label for="quantityLabel">Nº de impresiones</label>
							<input type="number" class="form-control form-control-sm" id="quantityLabel" v-model="quantityLabel"/>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click="printerLabelLocal" :disabled="btnPrinterLabelDisable">Imprimir</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" ref="btnArticuloGenesysModal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import genesys from '@/mixins/genesys'
	import articulo from '@/mixins/genesys/articulo.js'
	import label from "@/mixins/labels/"
	import webSocketServer from '@/mixins/webSocketServer.js'

	export default {
		name: 'ProductModalComponent',
        mixins: [mixin, errors, axiosAction, genesys, articulo, label, webSocketServer],
        props: ['item', 'listTypesProduct', 'listTypesBinding', 'listStatus', 'listEditorials', 'listStores', 'listStoreRacks', 'listStoreRackModules'],
		data () {
			return {
				closeAfterSave: true,
				searchArticulos: '',
				objectProductLocations: {
                    "id": '',
                    "product_id": '',
                    "store_id": '',
                    "store": 'q',
                    "store_rack_id": '',
                    "store_rack": 'q',
                    "store_rack_module_id": '',
                    "store_rack_module": 'q',
                    "quantity": 1
                },
				selectedLabelId: 0,
				quantityProduct: 0,
				quantityLabel: 1
			}
		},
		computed: {
			btnPrinterLabelDisable() {
				if(this.selectedLabelId < 1)
					return true
				if(isNaN(this.quantityLabel))
					return true
				if(this.quantityLabel < 1)
					return true
				if(this.selectedLabelId == 6) {
					if(isNaN(this.quantityProduct))
						return true
					if(this.quantityProduct < 1)
						return true					
				}
				return false
			},
			listStoresLocal() {
				return this.listStores
			},
			listStoreRacksLocal() {
				let listStoreRacks = this.listStoreRacks.filter(item => item.store_id == this.objectProductLocations.store_id );
				return listStoreRacks
			},
			listStoreRackModulesLocal() {
				let listStoreRackModules = this.listStoreRackModules.filter(item => item.store_rack_id == this.objectProductLocations.store_rack_id );
				return listStoreRackModules
			}
		},
		methods: {
			addProductLoationLocal() {
				this.clearObjectProductLocations()
				this.objectProductLocations.product_id = this.item.id
			},
			addProductPriceListLocal() {
				this.item.product_price_list.push({
					id: 0,
					product_id: 0,
					product: '',
					product_price_list_id: 0,
					product_price_list: '',
					date_begin: '',
					date_end: '',
					date_end: '',
					quantity: 1,
					price: '',
				})
				console.log(this.item)
			},
			clearObjectProductLocations() {
				this.objectProductLocations.id = 0
				this.objectProductLocations.product_id = ''
				this.objectProductLocations.store_id = ''
				this.objectProductLocations.store = ''
				this.objectProductLocations.store_rack_id = ''
				this.objectProductLocations.store_rack = ''
				this.objectProductLocations.store_rack_module_id = ''
				this.objectProductLocations.store_rack_module = ''
				this.objectProductLocations.quantity = 1
			},
			changeQuantity(item) {
				item.changeQuantity = true
				item.quantity = item.quantity + 1
				item.quantity = item.quantity - 1
				item.quantityOld = item.quantity
			},
			getArticulosLocal() {
				this.getArticulos()
			},
			btnPrinterLabelLocal() {
				this.selectedLabelId = 0
				this.quantityProduct = 0
				this.quantityLabel = 1
			},
			printerLabelLocal() {
				this.showLabel(this.selectedLabelId)
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'resultShowLabelGET': this.resultAxiosLocalLabel(responseLocal, response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			resultShowLabelGETLocal(response) {
				if(response.data.success == true) {
					let arrayZPL = []
					let quantityLabel = 1
					if(this.selectedLabelId == 6) {
						let name = this.item.name.substr(0, 40)
						let name_ = this.item.name.substr(40, 40)
						arrayZPL.push({'name': 'product_id' , 'value': this.item.id})
						arrayZPL.push({'name': 'isbn' , 'value': (this.item.isbn == null) ? '' : 'ISBN: ' + this.item.isbn})
						arrayZPL.push({'name': 'name' , 'value': name.toUpperCase()})
						arrayZPL.push({'name': 'name_' , 'value': name_.toUpperCase()})
						arrayZPL.push({'name': 'codbareti' , 'value': 'H' + this.item.id})
						arrayZPL.push({'name': 'quantity' , 'value': this.quantityProduct})
						quantityLabel = this.quantityLabel
					} else if (this.selectedLabelId == 7) {
						let length = 30
						let name = (this.item.name.length > length) ? this.item.name.substr(0, length - 3) + '...' : this.item.name
						arrayZPL.push({'name': 'id' , 'value': 'H' + this.fill(this.item.id, 10)})
						arrayZPL.push({'name': 'name' , 'value': name.toUpperCase()})
						quantityLabel = this.quantityLabel / 2
					}
					this.replaceZPLVariableFromArray(arrayZPL)
					for(let i = 0; i < quantityLabel; i++) {
						this.toPrintWithVariables()
					}
				}
			},
			saveProduct() {
				this.$emit('saveProduct')
				if(!this.closeAfterSave && this.item.exists == 0)
					this.$refs.btnCloseProductModalComponent.click()
			},
			saveProductLocation() {
				this.item.product_locations.push({store: 'hola'})
				this.$emit('saveProductLocation', this.objectProductLocations)
			},
			setValues() {

			},
			traerArticulo(it) {
				this.item.id = it.codart
				this.item.name = it.artdesc
				this.item.synthetic = it.artsintetico
				this.item.isbn = it.isbn
				this.item.length = it.largo
				this.item.width = it.ancho
				this.item.weight = it.peso
				this.$refs.btnArticuloGenesysModal.click()
			},
			showArticuloGenesysModal() {
				this.searchArticulos = ''
				this.listArticulos = []
			}
		},
	}</script>

	<!-- Add "scoped" attribute to limit CSS to this component only -->
	<style scoped lang="scss">
</style>
